import {
  getFieldOperators,
  getFilterFieldFromFieldName,
  getOperatorSentimentFromString,
} from '@modules/queryBuilder/helpers';
import { v4 } from 'uuid';
import { FieldName } from 'v2/core/entities/fields';
import { StringFilterValue } from 'v2/querybuilder/types/filtervalue';
import { QBFilter } from 'v2/querybuilder/types/qbNode';

interface toQueryFilterParams {
  values: string[];
  fieldName: FieldName | string;
  parent: string;
}

export const toQueryFilter = ({
  fieldName,
  parent,
  values,
}: toQueryFilterParams): QBFilter => {
  const field = getFilterFieldFromFieldName(fieldName);
  const operators = getFieldOperators({ field: field });

  return {
    id: v4(),
    type: 'filter',
    field: field || fieldName,
    parent,
    operator:
      field === 'entitySentiment'
        ? getOperatorSentimentFromString(JSON.parse(values[0])?.sentiment)
        : operators[0],
    value:
      field === 'entitySentiment'
        ? {
            type: 'string',
            value: JSON.parse(values[0])?.entity,
          }
        : {
            type: 'string[]',
            values: [
              ...values.map(
                (value): Required<StringFilterValue> => ({
                  type: 'string',
                  value,
                }),
              ),
            ],
          },
  };
};
